<template>
  <div class="login-module">
    <div class="login-tab">
      <div class="close-btn" @click="close">
        <span
          class="iconfont icon-a-CombinedShape4"
          style="font-size: 12px"
        ></span>
      </div>
      <p class="login-textc">教育魔方绑定</p>
      <p class="login-texte">Rubik's cube</p>
      <el-form :model="editForm" label-width="100px" ref="editForm">
        <div class="login-input" v-if="!activeIndex">
          <div class="phoneinput">
            <div class="phone">
              <img src="../../assets/images/username.png" alt />
            </div>
            <div class="c-input">
              <el-form-item type="primary">
                <el-input
                  placeholder="请输入账号"
                  v-model="editForm.username"
                  @input="disabledcodeClick"
                  @blur="verifyBlur"
                  maxlength="11"
                  autofocus
                ></el-input>
              </el-form-item>
              <div class="errorhint" v-show="errorhint">
                {{ errorhinttext }}
              </div>
            </div>
          </div>

          <div class="phoneinput">
            <div class="phone">
              <img src="../../assets/images/mima.png" alt />
            </div>
            <div class="c-input">
              <el-form-item type="primary">
                <!-- @blur="verifyBlurpassword" -->
                <el-input
                  placeholder="请输入密码"
                  @input="disabledcodeClick"
                  @blur="verifyBlurpassword"
                  maxlength="16"
                  v-model="editForm.password"
                  :type="passwordType"
                ></el-input>
                <img
                  v-show="isShoweye == true || editForm.password != ''"
                  v-if="passwordType != ''"
                  class="look"
                  src="../../assets/images/guangbi.png"
                  alt
                  @click="showPassword"
                />
                <img
                  v-show="isShoweye == true || editForm.password != ''"
                  v-else
                  class="look"
                  src="../../assets/images/chakan.png"
                  alt
                  @click="showPassword"
                />
              </el-form-item>
              <div class="errorhint" v-show="errorhintpass">
                {{ errorhinttextpass }}
              </div>
            </div>
          </div>

          <div class="register">
            <el-button
              type="primary"
              :class="[
                nextdisabled == false
                  ? 'el-button--primary'
                  : 'el-button--primaryno'
              ]"
              :disabled="nextdisabled"
              @click.native.prevent="loginClick"
              >{{ logintext }}</el-button
            >
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import AES from "@/utils/AES";
import {
  imgCaptcha,
  bindCubeUserInfo,
  getBoundLoginInfo,
  isUse,
  userById,
  disabled,
  authentication
} from "@/api/login";
import {
  setToken,
  setUuid,
  setroleId,
  setschoolId,
  setuserName,
  setuserPhone,
  setheadPath,
  setschoolCode,
  setrank,
  setIsAdmin,
  setorganFlag
} from "@/utils/auth";
import { info } from "@/api/province_Resource";
import { menuButtonByToken } from "@/api/power";
import { filterNUmber } from "@/utils/validate";
export default {
  components: {},
  props: {
    loginparameters: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loginval: "账号",
      activeIndex: false,
      checked: false,
      logintext: "绑定",
      hintpromptstate: false, //提示框状态
      markedwords: "", //提示框文字
      errorhint: false,
      errorhinttext: "",
      errorhintpass: false,
      errorhinttextpass: "",
      errorhintcode: false,
      errorhinttextcode: "",
      nextdisabled: true, //下一步颜色
      isShoweye: false,
      passwordType: "password",
      base64: "",
      logindata: this.loginparameters,
      editForm: {
        captcha: "", // 验证码
        captchaKey: "", // 验证码标识
        username: "",
        password: "",
        platformCode: window.g.platformCode //教育云平台
      },
      institution: [],
      jumpUrl: "",
      jumpHref: "",
      privatization: window.g.privatization,
      codedata: false,
      managerState: false
    };
  },
  watch: {
    "editForm.username": {
      handler(val, old) {
        if (val != null || val != "") {
          this.editForm.username = filterNUmber(val);
        }
      },
      immediate: true
    }
  },
  computed: {},
  methods: {
    // 获取验证码 图片
    img_code() {
      imgCaptcha().then(res => {
        this.editForm.captchaKey = res.data.captchaKey;
        this.base64 = res.data.imageBytes;
      });
    },
    //失去焦点验证手机格式
    verifyBlur() {
      if (this.editForm.username == "") {
        this.errorhint = true;
        this.errorhinttext = "请输入账号";
      } else {
        this.errorhint = false;
      }
      // let phoneInt = /^1[3456789]\d{9}$/;
      //   if (phoneInt.test(this.editForm.username) == false) {
      //   this.errorhint = true;
      //   this.errorhinttext = "请输入正确格式手机号码";
      // }
    },
    verifyBlurpassword() {
      const intnumber = new RegExp(/[\u4e00-\u9fa5/\s+/]$/);
      if (intnumber.test(this.editForm.password)) {
        this.errorhintpass = true;
        this.errorhinttextpass = "密码格式错误";
      } else {
        this.errorhintpass = false;
      }
    },
    // changeInstitution(items,index){
    //   this.jumpUrl = items.url
    // },
    getCaption(obj) {
      var index = obj.lastIndexOf("#");
      obj = obj.substring(index + 2, obj.length);
      return obj;
    },
    handleTab() {
      this.activeIndex = !this.activeIndex;
      if (this.activeIndex) {
        const path = this.getCaption(window.location.href);
        const type = "token";
        const data = 1;
        authentication(type, data, path).then(res => {
          if (res.code === 200) {
            this.institution = res.data;
            this.jumpUrl = this.institution[0].url;
          }
        });
        this.editForm = {
          captcha: "", // 验证码
          captchaKey: "", // 验证码标识
          username: "",
          password: ""
        };
        this.errorhint = false;
        this.loginval = "机构";
      } else {
        this.loginval = "账号";
      }
    },
    //输入框值发生变化时
    disabledcodeClick() {
      this.isShoweye = false;
      this.errorhint = false;
      if (this.editForm.password == "") {
        this.isShoweye = false;
        this.passwordType = "password";
      } else {
        this.isShoweye = true;
      }
      if (this.editForm.username != "" && this.editForm.password != "") {
        this.nextdisabled = false;
      } else {
        this.nextdisabled = true;
      }
    },

    //登录
    loginClick() {
      const pass = new RegExp(/[\u4e00-\u9fa5/\s+/]$/);
      const userna = new RegExp(
        /[\u4e00-\u9fa5/\s+/]|[-]|[`~!@#$%^&*()\+=<>?"{}|,\/;'\\[\].·~！@#￥%……&*（）——\+={}|《》？：“”【】、；‘’，。、]$/
      );

      if (this.editForm.username == "") {
        this.errorhint = true;
        this.errorhinttext = "请输入账号";
      } else if (this.editForm.password == "") {
        this.errorhintpass = true;
        this.errorhinttextpass = "请输入密码";
      }
      //  else if (this.editForm.captcha == "") {
      //   this.errorhintcode = true;
      //   this.errorhinttextcode = "请输入验证码";
      // } else if (userna.test(this.editForm.username)) {
      //   this.errorhint = true;
      //   this.errorhinttext = "账号或密码错误";
      // } else if (pass.test(this.editForm.password)) {
      //   this.errorhint = true;
      //   this.errorhinttext = "账号或密码错误";
      // } else if (
      //   this.editForm.username == "15811155833" &&
      //   this.managerState === false
      // ) {
      //   // 娄的账号，弹手机验证框
      //   this.codedata = true;
      // }
      else {
        this.errorhint = false;
        this.errorhintpass = false;
        this.errorhintcode = false;
        var AESusername = AES.encrypt(this.editForm.username);
        var AESpassword = AES.encrypt(this.editForm.password);
        let param = {
          cubeCommonUserId: this.$route.query.cubeCommonUserId,
          password: AESpassword,
          username: AESusername
        };
        if (this.checked === true && document.cookie.length < 1) {
          let username = Base64.encode(this.editForm.username);
          let password = Base64.encode(this.editForm.password);
          this.setCookie(username, password, 15);
        } else if (this.checked === false) {
          this.setCookie("", "", -1); // 修改2值都为空，天数为负1天就好了
        }

        bindCubeUserInfo(param).then(loginres => {
          if (loginres.code === 200) {
            getBoundLoginInfo("101", loginres.data.userId).then(res => {
              if (res.code === 200) {
                // localStorage.clear();
                localStorage.setItem("pageSize", 10);
                setToken(res.data.token);
                setUuid(res.data.user.uuid);
                localStorage.setItem("userId", res.data.user.uuid);
                // this.logintext = "登录中...";
                let userobj = {
                  userId: res.data.user.uuid
                };
                info(userobj).then(res => {
                  if (res.code === 200) {
                    setorganFlag(res.data.organFlag);
                    localStorage.subjectId = res.data.subjectId;
                    localStorage.subjectname = res.data.subjectName;
                  }
                });
                this.userbid(res);
              }
            });

            // 2010
          } else if (loginres.code === 2001) {
            this.managerState = false;
            this.codedata = false;
            this.errorhint = true;
            this.errorhinttext = "账号或密码错误";
            this.img_code();
          } else if (loginres.code === 3000) {
            this.managerState = false;
            this.codedata = false;
            this.errorhintcode = true;
            this.errorhinttextcode = loginres.msg;
            this.img_code();
          } else if (loginres.code === 1006) {
            this.managerState = false;
            this.codedata = false;
            setToken(loginres.data.token);
            setUuid(loginres.data.userId);
            // this.$confirm('为了确保您的账号安全，建议您修改初始密码', '', {
            //   confirmButtonText: '去修改',
            //   cancelButtonText: '跳过',
            //   center:true,
            //   customClass:"loginsetPass"
            // }).then(() => {
            localStorage.defaultdata = true;
            this.$store.commit("loginState", true);
            this.logindata.defaultdata = true;
            this.logindata.logindata = false;
            // }).catch(() => {
            //   this.$store.commit('loginState', false);
            //   if (userres.data.userId == 1) {
            //     localStorage.setItem(
            //       "routerpath",
            //       JSON.stringify("/group/probable")
            //     );
            //     setTimeout(() => {
            //       this.$router.replace({ path: "/group/probable" });
            //       this.hintpromptstate = false;
            //     }, 1000);
            //     // this.hintpromptstate = true;
            //     // this.markedwords = "登录成功";
            //   } else {
            //     localStorage.setItem(
            //       "routerpath",
            //       JSON.stringify("/group/personal")
            //     );
            //     setTimeout(() => {
            //       this.$router.replace({ path: "/group/personal" });
            //       this.hintpromptstate = false;
            //     }, 1000);
            //     // this.hintpromptstate = true;
            //     // this.markedwords = "登录成功";
            //   }
            //   //存储权限按钮
            //   menuButtonByToken(userres.data.roleId).then((menuButtonres) => {
            //     if (menuButtonres.code === 200) {
            //       let buttons = menuButtonres.data;
            //       localStorage.setItem(
            //         "ButtonPermissions",
            //         JSON.stringify(buttons)
            //       );
            //       location.reload()
            //     }
            //   });
            // });
          } else if (loginres.code === 1007) {
            this.managerState = false;
            this.codedata = false;
            localStorage.IPveiwdata = true;
            // localStorage.username = loginres.data.username;
            // this.$emit('go',loginres.data.username)
            localStorage.userDate = JSON.stringify(add);
            this.logindata.username = loginres.data.username;
            this.logindata.Ipstate = true; // ip验证
            this.logindata.logindata = false;
            this.logindata.defaultdata = false;
            this.logindata.logindata = false;
          } else if (loginres.code === 1008) {
            this.managerState = false;
            this.codedata = false;
            this.$message({
              dangerouslyUseHTMLString: true,
              duration: 5000,
              message:
                "<strong>" +
                loginres.msg +
                '。<span onclick="accountErr()" style="color:#333;cursor:pointer;">点击找回密码</span></strong>',
              center: true,
              type: "error"
            });
            this.img_code();
          } else if (loginres.code === 1009) {
            this.managerState = false;
            this.codedata = false;
            this.$message({
              dangerouslyUseHTMLString: true,
              duration: 5000,
              message:
                "<strong>" +
                loginres.msg +
                '。<span onclick="accountErr()" style="color:#333;cursor:pointer;">点击找回密码</span></strong>',
              center: true,
              type: "error"
            });
            this.img_code();
          } else {
            this.managerState = false;
            this.codedata = false;
            this.errorhint = true;
            this.errorhinttext = loginres.msg;
            this.img_code();
          }
        });
      }
    },
    userbid(loginres) {
      userById(loginres.data.user.uuid).then(userres => {
        //   //这里到时候判断schoolCode
        // if ( userres.data.schoolId != "" ||userres.data.userId == 1) {
        setuserPhone(userres.data.username);
        setroleId(userres.data.roleId);
        setuserName(userres.data.name);
        setschoolId(userres.data.aff);
        setrank(userres.data.roleLevel);
        setIsAdmin(userres.data.isAdmin);
        setheadPath(userres.data.headPath);
        setschoolCode(userres.data.schoolCode);
        // 截取手机号后六位
        // const usertel = this.editForm.username.substring(this.editForm.username.length - 6);
        // usertel === this.editForm.password
        // Ipstate
        this.$store.commit("loginState", false);
        let paurl = localStorage.appointPath;
        let query = localStorage.appointQuery; // 登录成功，跳转参数
        if (userres.data.userId == 1) {
          localStorage.setItem("routerpath", JSON.stringify("/group/probable"));
          // setTimeout(() => {
          if (paurl) {
            this.$router.replace({ path: paurl });
          } else {
            this.$router.replace({ path: "/group/probable" });
          }
          this.hintpromptstate = false;
          this.cun(userres);
          // }, 800);
          // this.hintpromptstate = true;
          // this.markedwords = "登录成功";
        } else {
          // localStorage.appointPath
          localStorage.setItem("routerpath", JSON.stringify("/group/personal"));
          // setTimeout(() => {
          if (paurl && query) {
            // 跳转登录前，将要跳转的地址
            console.log("登录零零零零");
            this.$router.push({
              path: paurl,
              query: JSON.parse(query)
            });
            // 清除前台跳转后台本地存储的临时数据
            localStorage.removeItem("appointQuery");
            return;
          } else if (paurl) {
            this.$router.replace({ path: paurl });
          } else {
            this.$router.replace({ path: "/group/personal" });
          }
          this.hintpromptstate = false;
          this.cun(userres);
          // }, 800);
          // this.hintpromptstate = true;
          // this.markedwords = "登录成功";
        }
      });
    },
    cun(userres) {
      //存储权限按钮
      menuButtonByToken(userres.data.roleId).then(menuButtonres => {
        if (menuButtonres.code === 200) {
          let buttons = menuButtonres.data;
          localStorage.setItem("ButtonPermissions", JSON.stringify(buttons));
          // setTimeout(() => {
          // }, 500)
          localStorage.removeItem("defaultdata");
          localStorage.removeItem("userDate");
          location.reload();
        }
      });
      localStorage.removeItem("user");
    },
    setCookie(username, password, exdays) {
      var exdate = new Date(); // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); // 保存的天数
      // 字符串拼接cookie
      window.document.cookie =
        "userName" + "=" + username + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "userPwd" + "=" + password + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "isRemember" +
        "=" +
        this.checked +
        ";path=/;expires=" +
        exdate.toGMTString();
    },
    getCookie() {
      var self = this;
      // 判断cookie里是否有数据
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); // 这里显示的格式需要切割一下自己可输出看下
        let username = "";
        let userpassword = "";
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); // 再次切割
          // // 判断查找相对应的值
          if (arr2[0] === "userName") {
            // console.log(arr2[1])
            username = Base64.decode(arr2[1]); // 取到的保存数据
          } else if (arr2[0] === "userPwd") {
            // console.log(arr2[1])
            userpassword = Base64.decode(arr2[1]); // 取到的保存数据
          } else if (arr2[0] === "isRemember") {
            // console.log(Boolean(arr2[1]))
            this.checked = Boolean(arr2[1]);
          }
        }
        if (this.checked) {
          this.editForm.username = username; //取到的保存数据
          this.editForm.password = userpassword; //取到的保存数据
        } else {
          this.setCookie("", "", -1);
        }
      }
    },
    enterKey(event) {
      if (event.keyCode === 13) {
        this.loginClick();
      }
    },
    enterKeyupDestroyed() {
      document.removeEventListener("keyup", this.enterKey);
    },
    enterKeyup() {
      document.addEventListener("keyup", this.enterKey);
    },

    showPassword() {
      this.passwordType === ""
        ? (this.passwordType = "password")
        : (this.passwordType = "");
    },
    registerClick() {
      this.logindata.logindata = false;
      this.logindata.registerdata = true;
      this.logindata.forgetdata = false;
    },
    forgetClick() {
      this.$confirm(
        "如果您的身份为学生，请联系班主任重置密码，此处仅支持教师使用手机号找回密码",
        "",
        {
          confirmButtonText: "我知道了",
          center: true,
          showCancelButton: false
        }
      )
        .then(() => {
          this.logindata.logindata = false;
          this.logindata.registerdata = false;
          this.logindata.forgetdata = true;
        })
        .catch(() => {});
    },
    close() {
      this.$store.commit("loginState", false);
      // 清除前台跳转后台本地存储的临时数据
      localStorage.removeItem("appointQuery");
    },
    onEsc() {
      // 关闭手机验证弹出
      this.codedata = false;
    },
    getLogin() {
      // 手机验证码通过，调登录方法
      this.managerState = true;
      this.loginClick();
    }
  },
  mounted() {
    // 将事件绑定到window下
    (window["accountErr"] = () => {
      this.forgetClick();
    }),
      // 绑定enter事件
      this.enterKeyup();
    this.img_code();
    this.getCookie();
  },
  destroyed() {
    // 销毁enter事件
    this.enterKeyupDestroyed();
  },
  created() {},
  updated() {}
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import './index.styl';
</style>
<style>
.loginsetPass .el-icon-close {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/wx-eduCubeBind/index.vue